import React from 'react';
import { useTranslation } from 'react-i18next';

import Container from 'components/Container';

import {
  Section,
  Content,
  Item,
  Title,
  Subtitle,
  TechGrid,
  TechCard,
  TechIcon,
  TechLabel,
} from './Toolbox.styles';

const Toolbox = () => {
  const [t] = useTranslation('global');

  const technologies = [
    {
      key: 'tech1',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg',
      color: '#61DAFB',
    },
    {
      key: 'tech2',
      logo: 'https://seeklogo.com/images/A/anthropic-logo-E1B9C9BC4E-seeklogo.com.png',
      color: '#FF7A00',
    },
    {
      key: 'tech3',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/fastapi/fastapi-original.svg',
      color: '#009688',
    },
    {
      key: 'tech4',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg',
      color: '#47A248',
    },
    {
      key: 'tech5',
      logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg',
      color: '#3776AB',
    },
    {
      key: 'tech6',
      logo: 'https://railway.app/brand/logo-light.svg',
      color: '#ffffff',
    },
  ];

  return (
    <Section id="toolbox">
      <Container>
        <Content>
          <Item>
            <Title>{t('toolbox.our')}</Title>
            <Subtitle>{t('toolbox.trick')}</Subtitle>
          </Item>

          <TechGrid>
            {technologies.map((tech) => (
              <TechCard key={tech.key}>
                <TechIcon>
                  <img
                    src={tech.logo}
                    alt={t(`toolbox.${tech.key}`)}
                    width="60"
                    height="60"
                    onError={(e) => {
                      if (tech.key === 'tech2') {
                        e.target.style.display = 'none';
                        e.target.parentNode.innerHTML =
                          '<div style="font-size: 28px; color: #FF7A00;">🤖</div>';
                      }
                    }}
                  />
                </TechIcon>
                <TechLabel>
                  <h3>{t(`toolbox.${tech.key}`)}</h3>
                </TechLabel>
              </TechCard>
            ))}
          </TechGrid>
        </Content>
      </Container>
    </Section>
  );
};

export default Toolbox;
